/**
 * Created by abbeymart on 2016-12-26. | Updated: 2020-07-04
 */
import { getStartRoutes } from './common/getStartRoutes';
import { techGuideRoutes } from './common/techGuideRoutes';
import { userGuideRoutes } from './common/userGuideRoutes';
import { kBaseRoutes } from './common/kBaseRoutes';
import { newsRoutes } from './common/newsRoutes';
import { supportRoutes } from './common/supportRoutes';
import { favouriteRoutes } from './common/favouriteRoutes';
import { documentationRoutes } from 'src/router/central/documentationRoutes';

export const commonRoutes = [
  ...getStartRoutes,
  ...techGuideRoutes,
  ...userGuideRoutes,
  ...kBaseRoutes,
  ...newsRoutes,
  ...favouriteRoutes,
  ...supportRoutes,
  ...documentationRoutes
];
